export enum MediaRoot {
  Gallery = 'GALLERY',
  Camera = 'CAMERA',
  Unknown = 'UNKNOWN',
}
